export enum EVENTS {
  // USER
  ORDER_PLACED = 'Order Placed',
  ORDER_MODIFIED = 'Confirm Modify Order',
  ORDER_CANCELLED = 'Order Cancelled',
  ORDER_FAILED = 'Order Validation Failed',
  LOGGED_IN = 'Logged In',
  LOGGED_OUT = 'Logged Out',

  // TRANSACTION
  HOLDINGS_VIEWED = 'Holdings Viewed',
  ORDER_SUMMARY_VIEWED = 'Order Summary Viewed',
  POSITIONS_VIEWED = 'Positions Viewed',
  OPTION_CHAIN_VIEWED = 'Option Chain Viewed',

  // ADD FUNDS
  ADD_FUNDS = 'TV Add Funds',

  // CHART INDICATOR
  CHART_ADDED_INDICATOR = 'Added Indicator',

  // User agent details
  USER_AGENT = 'User agent',
  PIN_TO_TV_CHART_LOAD_TIME = '2FA to TV Chart Time Taken',
  SYMBOL_CHANGE = 'Symbol Change',
  INTERVAL_CHANGE = 'Interval Change',

  // Unsupported Browser
  BROWSER_WARNING_VIEWED = 'Browser Warning Viewed',
  BROWSER_WARNING_CONTINUE = 'Browser Warning Continued',
  BROWSER_WARNING_LOGOUT = 'Browser Warning Logout',
  BROWSER_WARNING_CLOSED = 'Browser Warning Closed',

  // Brokerage Charges Error
  BROKERAGE_AND_CHARGES_ERROR = 'Brokerage and Charges error',

  // Brokerage Charges Error
  INSTRUMENT_DATA_API_ERROR = 'Instrument data fetch error',

  // Pre-Risk Error
  PRE_RISK_ERROR = 'Pre-Risk service error',
  PRE_RISK_ERROR_FOR_MULTIPLE_ORDERS = 'Pre Risk Warning Error Multiple Orders',

  // Launch Darkly Initialization Failure
  LAUNCH_DARKLY_FAILURE = 'Launch Darkly failed to initialize',

  // Save TV Charts
  TOTAL_TV_CHARTS_SAVED = 'Total TV charts saved',
  SAVED_TV_CHART_SIZE = 'Saved TV chart size',

  // Save TV Templates
  TOTAL_TV_STUDY_TEMPLATES_SAVED = 'Total TV templates saved',
  SAVED_TV_STUDY_TEMPLATE_SIZE = 'Saved TV template size',

  // Moving Recent Layout to Saved Layout
  MOVE_RECENT_TO_UPSTOX_LAYOUT = 'Moving Recent to Upstox Layout',
  SAVING_EMPTY_UPSTOX_LAYOUT = 'Saving Empty Upstox Layout',

  // CHART SETTINGS
  CHART_SIZE = 'Chart Size',
  CHART_SIZE_EXCEEDED = 'Chart Size Exceeded',
  CHART_SETTINGS_SAVE_ERROR = 'TV Chart Settings Save Error',
  CHART_SETTINGS_GET_ERROR = 'TV Chart Settings Get Error',
  CHART_SETTINGS_LIST_GET_ERROR = 'TV Chart Settings List Get Error',
  CHART_SETTINGS_DELETE_ERROR = 'TV Chart Settings Delete Error',
  CHART_SAVE_REQUEST_CANCELLED = 'TV Chart Save Request Cancelled',
  // CHART SYNCING
  CHART_SAVE_USER_PREFERENCE = 'Chart Save User Preference',
  CHART_SAVE_SELECTED_OPTION = 'Chart Save Selected Option',
  CHART_SAVE_CONFIRMED_OPTION = 'Chart Save Confirmed Option',
  CHART_SAVE_SYNC_SUCCESS = 'Chart Save Sync Success',
  CHART_SAVE_SYNC_FAILED = 'Chart Save Sync Failed',
  CHART_AUTO_SYNC = 'Chart Auto Sync Started',
  // Fingerprint JS failure
  FINGERPRINT_JS_FAILURE = 'Fingerprint JS failure',
  FINGERPRINT_JS_VISIOR_ID_FAILURE = 'Fingerprint JS get visitor id failure',

  // notification events
  CUSTOM_IN_APP_NOTIFICATION_SHOWN = 'custom inapp notification shown',
  CUSTOM_IN_APP_NOTIFICATION_CTA_CLICK = 'custom inapp notification CTA click',
  NOTIFICATION_RESPONSE_PARSING_ERROR = 'Notification API Response Parsing Error',
  NOTIFICATION_RESPONSE_FAILURE = 'Notification Response Failure',
  EXPIRING_NOTIFICATION_RESPONSE_FAILURE = 'Expiring Notification Response Failure',

  // Incognito window
  INCOGNITO_WINDOW = 'Incognito window',

  // CleverTap
  UI_PUSH_PROMPT_ACCEPTED = 'UI Push Prompt Accepted',
  UI_PUSH_PROMPT_REJECTED = 'UI Push Prompt Rejected',
  NATIVE_PUSH_PROMPT_ACCEPTED = 'Native Push Prompt Accepted',

  // Storage
  LOCAL_STORAGE_FULL = 'Local storage full',

  // FCM
  FCM_FAILED_GET_TOKEN = 'Failed FCM Token Generation',
  FCM_FAILED_DATA_PARSE = 'Failed Parsing FCM Data',
  ERROR_OCCURRED = 'TV Error Occurred',

  // Web socket
  WEB_SOCKET_CONNECTED = 'Web Socket Connected',
  WEB_SOCKET_DISCONNECTED = 'Web Socket Disconnected',

  // Custom Interval
  CUSTOM_INTERVAL_ADDED = 'Added Custom Interval On Chart',

  // ASBA registration/deregistration in pending state
  ASBA_REGISTRATION_OR_DEREGISTRATION_IN_PROGRESS = 'ASBA user UPI Allocation is in progress',

  CONTINUOUS_CHARTS_ENABLED = 'Continuous futures enabled',

  OPTION_CHAIN_CLICK = 'Option chain click',

  // Positions MTM Exit All
  POSITIONS_MTM_EXIT_ALL_BUTTON_CLICKED = 'Positions MTM Exit All Button Clicked',
  POSITIONS_MTM_EXIT_ALL_CANCELLED = 'Positions MTM Exit All Cancelled',
  POSITIONS_MTM_EXIT_ALL_EXECUTED = 'Positions MTM Exit All Executed',

  // Price Alert
  PRICE_ALERTS_ERROR = 'TV Price Alerts Error',
  PRICE_ALERT_CREATE_BUTTON_CLICK = 'Create Alert Button Clicked ',
  PRICE_ALERT_EDIT_BUTTON_CLICKED = 'Edit Alert Button Clicked',
  PRICE_ALERT_DELETE_BUTTON_CLICKED = 'Delete Alert Button Clicked',
  PRICE_ALERT_TRIGGERED = 'Price Alert Triggered ',
  // EDIS Authorisation
  AUTHORISE_EDIS = 'Authorise Edis',
  AUTHORISE_EDIS_ERROR = 'Authorise Edis Error',
  OPEN_INTERIM_PAGE_FOR_EDIS = 'Open Interim Page for eDIS',
  EDIS_NOT_REQUIRED = 'Edis Not Required',
  TRANSACTION_STATUS_EDIS = 'Transaction Status InApp for eDIS',

  // Icon button
  ICON_CLICKED = 'Icon Clicked',
  COMMUNITY_ICON_CLICKED = 'Community Icon Clicked',

  // Surveillance Event
  SECURITY_UNDER_SURVEILLANCE = 'Security Surveillance',

  // Firebase Remote Config
  REMOTE_CONFIG_FAILURE = 'Firebase Remote Config failed to initialize',

}
